var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',_vm._b({attrs:{"label":_vm.label,"value":_vm.value,"color":_vm.ada.blue,"rows":_vm.rows ? _vm.rows : 10,"disabled":_vm.disabled},on:{"input":function($event){return _vm.$emit('input', $event)}}},'v-textarea',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }